import { ChakraProvider, createSystem, defaultConfig, defineConfig, mergeConfigs, Spinner, Box } from '@chakra-ui/react'
import { Outlet, useParams } from 'react-router-dom'
import { PilotSessionProvider, usePilotSession } from './PilotSessionContext'

function PilotThemeWrapper({ children }: { children: React.ReactNode }) {
  const { config, configLoading } = usePilotSession()

  if (configLoading) {
    return (
      <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
        <Spinner size="xl" />
      </Box>
    )
  }

  const primary = config?.brandPrimaryColor ?? '#005A9C'
  const secondary = config?.brandSecondaryColor ?? '#00A499'

  const councilConfig = defineConfig({
    theme: {
      tokens: {
        colors: {
          brand: {
            500: { value: primary },
            600: { value: primary },
            secondary: { value: secondary },
          },
        },
      },
    },
  })

  const system = createSystem(mergeConfigs(defaultConfig, councilConfig), {
    cssVarsPrefix: 'pilot',
  })

  return (
    <ChakraProvider value={system}>
      {children}
    </ChakraProvider>
  )
}

const PilotLayout: React.FC = () => {
  return (
    <PilotSessionProvider>
      <PilotThemeWrapper>
        <Box minH="100vh" bg="gray.50">
          <Outlet />
        </Box>
      </PilotThemeWrapper>
    </PilotSessionProvider>
  )
}

export default PilotLayout
